<template>
  <Tooltip :content="title" :disabled="!title">
    <div class="app-icon-button"
      :class="{
        'app-icon-button-disabled':disabled
      }"
     :style="`background:${!active?'none':''}`">
        <BaseIcon
          :icon="icon"
          :size="size"
          :color="active?'#fff':'#888'"
          class="app-icon"
          @click="$emit('on-click')"
          :style="{'border-color':active?'#fff':'#888'}">
        </BaseIcon>
    </div>
  </Tooltip>
</template>

<script>
export default {
  props: {
    'title': {
      type: String,
      default: '',
    },
    'icon': {
      type: String,
      default: 'md-circle',
    },
    'size': {
      type: Number,
      default: 15,
    },
    'active': {
      type: Boolean,
      default: false,
    },
    'disabled': {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less">
.in-app{
  .app-icon-button{
    background:var(--primary);padding:2px;border-radius:8px;
    .app-icon{
      border-radius:7px;border:2px solid #fff;padding:4px;position:relative;cursor:pointer;z-index:5;transition:all 0.5s;
    }
  }

  .app-icon-button:hover{
    filter:brightness(1.1);
  }

  .app-icon-button:hover{
    filter:brightness(1.1);
  }

  .app-icon-button:active{
    position: relative;
    bottom:-1px;
    right:-1px;
  }

  .app-icon-button-disabled{

    background:none !important;
    .app-icon{
       cursor: default !important;
      border-color:#33333333 !important;
      color:#33333333 !important;
    }
  }
}

</style>
